import React from 'react';
import { 
  Clock, 
  Award, 
  Zap, 
  Trophy,
  History,
  Hourglass,
  CheckCircle2,
  Star
} from 'lucide-react';
import './Dto43b2.css';

const Dto43b2: React.FC = () => {
  return (
    <div className="dto43b2">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Enhanced Efficiency</h1>
          <p>Faster Treatment, Superior Results</p>
        </div>
      </div>

      {/* Time Efficiency Section */}
      <section className="efficiency-section container">
        <div className="efficiency-content">
          <div className="efficiency-text">
            <h2>Optimized Treatment Time</h2>
            <p>
              At Yueting, we understand the value of your time. Our award-winning digital 
              process, combined with Snow Porcelain Pro's advanced features, significantly 
              reduces consultation and treatment duration without compromising quality.
            </p>
          </div>
          <div className="time-savings">
            <div className="saving-card">
              <Clock className="saving-icon" />
              <h3>Reduced Consultation Time</h3>
              <p>Streamlined digital processes for faster, more efficient appointments</p>
            </div>
            <div className="saving-card">
              <Zap className="saving-icon" />
              <h3>Faster Procedures</h3>
              <p>Advanced materials and techniques minimize treatment duration</p>
            </div>
          </div>
        </div>
      </section>

      {/* Innovation Timeline */}
      <section className="timeline-section">
        <div className="container">
          <h2 className="section-title">Our Innovation Journey</h2>
          <div className="timeline">
            <div className="timeline-item">
              <History className="timeline-icon" />
              <div className="timeline-content">
                <h3>2014</h3>
                <p>Introduction of Digital Process</p>
              </div>
            </div>
            <div className="timeline-item">
              <Trophy className="timeline-icon" />
              <div className="timeline-content">
                <h3>2019-2021</h3>
                <p>National Innovation Awards</p>
              </div>
            </div>
            <div className="timeline-item">
              <Star className="timeline-icon" />
              <div className="timeline-content">
                <h3>Present</h3>
                <p>Snow Porcelain Pro Launch</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Improvements */}
      <section className="improvements-section">
        <div className="container">
          <h2 className="section-title">Efficiency Improvements</h2>
          <div className="improvements-grid">
            <div className="improvement-card">
              <Award className="improvement-icon" />
              <h3>Digital Excellence</h3>
              <p>
                Award-winning digital processes that streamline treatment planning and 
                execution.
              </p>
            </div>
            <div className="improvement-card">
              <Hourglass className="improvement-icon" />
              <h3>Time Optimization</h3>
              <p>
                Reduced grinding time and simplified adhesive application process.
              </p>
            </div>
            <div className="improvement-card">
              <CheckCircle2 className="improvement-icon" />
              <h3>Predictable Results</h3>
              <p>
                High-quality output with minimal need for adjustments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quality Assurance */}
      <section className="quality-section container">
        <div className="quality-content">
          <div className="quality-text">
            <h2>World-Class Standards</h2>
            <p>
              Since 2014, we've continuously evolved our processes, updated materials, 
              and refined techniques to maintain pace with global advancements in dental 
              technology. Our commitment to excellence ensures that every treatment meets 
              international standards while maximizing efficiency.
            </p>
          </div>
          <div className="quality-image">
            <img 
              src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&q=80&w=1500"
              alt="Dental Technology"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dto43b2;